import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e09cbef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "slide-design-panel" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "row tr_row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"1"} }, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "background-image-wrapper"
}
const _hoisted_6 = { class: "background-image" }
const _hoisted_7 = {
  key: 1,
  class: "background-gradient-wrapper"
}
const _hoisted_8 = { class: "row tr_row" }
const _hoisted_9 = { style: {"flex":"2"} }
const _hoisted_10 = { class: "row tr_row" }
const _hoisted_11 = { style: {"flex":"2"} }
const _hoisted_12 = {
  key: 0,
  class: "row tr_row"
}
const _hoisted_13 = { style: {"flex":"2"} }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "row tr_row" }
const _hoisted_16 = { style: {"flex":"2"} }
const _hoisted_17 = { class: "title" }
const _hoisted_18 = { class: "row tr_row" }
const _hoisted_19 = { style: {"flex":"2"} }
const _hoisted_20 = { class: "row tr_row" }
const _hoisted_21 = { style: {"flex":"2"} }
const _hoisted_22 = { class: "row tr_row" }
const _hoisted_23 = { style: {"flex":"2"} }
const _hoisted_24 = { class: "row tr_row" }
const _hoisted_25 = { style: {"flex":"2"} }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "title" }
const _hoisted_28 = { class: "theme-list" }
const _hoisted_29 = { class: "theme-item-content" }
const _hoisted_30 = { class: "colors" }
const _hoisted_31 = { class: "btns" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["onClick"]

import { computed, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import { SlideBackground, SlideTheme } from '@/types/slides'
import { PRESET_THEMES } from '@/configs/theme'
import { WEB_FONTS } from '@/configs/font'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'
import useSlideTheme from '@/hooks/useSlideTheme'
import { getImageDataURL } from '@/utils/image'
import { useI18n } from 'vue-i18n'
import ColorButton from './common/ColorButton.vue'
import FileInput from '@/components/FileInput.vue'
import ColorPicker from '@/components/ColorPicker/index.vue'
import {
  Divider,
  Button,
  Popover,
  Slider,
  Select,
} from 'ant-design-vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'SlideDesignPanel',
  setup(__props) {

const { t, locale } = useI18n()

const { OptGroup: SelectOptGroup, Option: SelectOption } = Select

const slidesStore = useSlidesStore()
const { availableFonts } = storeToRefs(useMainStore())
const { slides, currentSlide, viewportRatio, theme } = storeToRefs(slidesStore)

const background = computed(() => {
  if (!currentSlide.value || !currentSlide.value.background) {
    return {
      type: 'solid',
      value: '#fff',
    } as SlideBackground
  }
  return currentSlide.value.background
})

const { addHistorySnapshot } = useHistorySnapshot()
const {
  applyPresetThemeToSingleSlide,
  applyPresetThemeToAllSlides,
  applyThemeToAllSlides,
} = useSlideTheme()

// 设置背景模式：纯色、图片、渐变色
const updateBackgroundType = (type: 'solid' | 'image' | 'gradient') => {
  if (type === 'solid') {
    const newBackground: SlideBackground = {
      ...background.value,
      type: 'solid',
      color: background.value.color || '#fff',
    }
    slidesStore.updateSlide({ background: newBackground })
  }
  else if (type === 'image') {
    const newBackground: SlideBackground = {
      ...background.value,
      type: 'image',
      image: background.value.image || '',
      imageSize: background.value.imageSize || 'cover',
    }
    slidesStore.updateSlide({ background: newBackground })
  }
  else {
    const newBackground: SlideBackground = {
      ...background.value,
      type: 'gradient',
      gradientType: background.value.gradientType || 'linear',
      gradientColor: background.value.gradientColor || ['#fff', '#fff'],
      gradientRotate: background.value.gradientRotate || 0,
    }
    slidesStore.updateSlide({ background: newBackground })
  }
  addHistorySnapshot()
}

// 设置背景图片
const updateBackground = (props: Partial<SlideBackground>) => {
  slidesStore.updateSlide({ background: { ...background.value, ...props } })
  addHistorySnapshot()
}

// 上传背景图片
const uploadBackgroundImage = (files: FileList) => {
  const imageFile = files[0]
  if (!imageFile) return
  getImageDataURL(imageFile).then(dataURL => updateBackground({ image: dataURL }))
}

// 应用当前页背景到全部页面
const applyBackgroundAllSlide = () => {
  const newSlides = slides.value.map(slide => {
    return {
      ...slide,
      background: currentSlide.value.background,
    }
  })
  slidesStore.setSlides(newSlides)
  addHistorySnapshot()
}

// 设置主题
const updateTheme = (themeProps: Partial<SlideTheme>) => {
  slidesStore.setTheme(themeProps)
}

// 设置画布尺寸（宽高比例）
const updateViewportRatio = (value: number) => {
  slidesStore.setViewportRatio(value)
}

return (_ctx: any,_cache: any) => {
  const _component_IconPlus = _resolveComponent("IconPlus")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(`editor.toolbar.panel.background`)), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(Select), {
        style: {"flex":"10"},
        value: _unref(background).type,
        onChange: _cache[0] || (_cache[0] = value => updateBackgroundType(value as 'gradient' | 'image' | 'solid'))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(SelectOption), { value: "solid" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(`editor.toolbar.panel.solid`)), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(SelectOption), { value: "image" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(`editor.toolbar.panel.image`)), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(SelectOption), { value: "gradient" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(`editor.toolbar.panel.gradient`)), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"]),
      _hoisted_4,
      (_unref(background).type === 'solid')
        ? (_openBlock(), _createBlock(_unref(Popover), {
            key: 0,
            trigger: "click"
          }, {
            content: _withCtx(() => [
              _createVNode(ColorPicker, {
                modelValue: _unref(background).color,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = color => updateBackground({ color }))
              }, null, 8, ["modelValue"])
            ]),
            default: _withCtx(() => [
              _createVNode(ColorButton, {
                color: _unref(background).color || '#fff',
                style: {"flex":"10"}
              }, null, 8, ["color"])
            ]),
            _: 1
          }))
        : (_unref(background).type === 'image')
          ? (_openBlock(), _createBlock(_unref(Select), {
              key: 1,
              style: {"flex":"10"},
              value: _unref(background).imageSize || 'cover',
              onChange: _cache[2] || (_cache[2] = value => updateBackground({ imageSize: value as 'repeat' | 'cover' | 'contain' }))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(SelectOption), { value: "contain" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(`editor.toolbar.panel.contain`)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(SelectOption), { value: "repeat" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(`editor.toolbar.panel.repeat`)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(SelectOption), { value: "cover" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(`editor.toolbar.panel.cover`)), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"]))
          : (_openBlock(), _createBlock(_unref(Select), {
              key: 2,
              style: {"flex":"10"},
              value: _unref(background).gradientType,
              onChange: _cache[3] || (_cache[3] = value => updateBackground({ gradientType: value as 'linear' | 'radial' }))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(SelectOption), { value: "linear" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(`editor.toolbar.panel.linear`)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(SelectOption), { value: "radial" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(`editor.toolbar.panel.radial`)), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"]))
    ]),
    (_unref(background).type === 'image')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(FileInput, {
            onChange: _cache[4] || (_cache[4] = files => uploadBackgroundImage(files))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: "content",
                  style: _normalizeStyle({ backgroundImage: `url(${_unref(background).image})` })
                }, [
                  _createVNode(_component_IconPlus)
                ], 4)
              ])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_unref(background).type === 'gradient')
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t(`editor.toolbar.panel.startColor`)) + "：", 1),
            _createVNode(_unref(Popover), { trigger: "click" }, {
              content: _withCtx(() => [
                _createVNode(ColorPicker, {
                  modelValue: _unref(background).gradientColor![0],
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = value => updateBackground({ gradientColor: [value, _unref(background).gradientColor![1]] }))
                }, null, 8, ["modelValue"])
              ]),
              default: _withCtx(() => [
                _createVNode(ColorButton, {
                  color: _unref(background).gradientColor![0],
                  style: {"flex":"3"}
                }, null, 8, ["color"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t(`editor.toolbar.panel.endColor`)) + "：", 1),
            _createVNode(_unref(Popover), { trigger: "click" }, {
              content: _withCtx(() => [
                _createVNode(ColorPicker, {
                  modelValue: _unref(background).gradientColor![1],
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = value => updateBackground({ gradientColor: [_unref(background).gradientColor![0], value] }))
                }, null, 8, ["modelValue"])
              ]),
              default: _withCtx(() => [
                _createVNode(ColorButton, {
                  color: _unref(background).gradientColor![1],
                  style: {"flex":"3"}
                }, null, 8, ["color"])
              ]),
              _: 1
            })
          ]),
          (_unref(background).gradientType === 'linear')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t(`editor.toolbar.panel.rotate`)) + "：", 1),
                _createVNode(_unref(Slider), {
                  class: "slider",
                  min: 0,
                  max: 360,
                  step: 15,
                  value: _unref(background).gradientRotate,
                  onChange: _cache[7] || (_cache[7] = value => updateBackground({ gradientRotate: value as number }))
                }, null, 8, ["value"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_unref(Button), {
        style: {"flex":"1"},
        onClick: _cache[8] || (_cache[8] = ($event: any) => (applyBackgroundAllSlide()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t(`editor.toolbar.panel.useBackgroundToAll`)), 1)
        ]),
        _: 1
      })
    ]),
    _createVNode(_unref(Divider)),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t(`editor.toolbar.slideDesignPanel.canvasSize`)) + "：", 1),
      _createVNode(_unref(Select), {
        style: {"flex":"3"},
        value: _unref(viewportRatio),
        onChange: _cache[9] || (_cache[9] = value => updateViewportRatio(value as number))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(SelectOption), { value: 0.5625 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(`editor.toolbar.slideDesignPanel.wideScreen1`)), 1)
            ]),
            _: 1
          }, 8, ["value"]),
          _createVNode(_unref(SelectOption), { value: 0.625 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(`editor.toolbar.slideDesignPanel.wideScreen2`)), 1)
            ]),
            _: 1
          }, 8, ["value"]),
          _createVNode(_unref(SelectOption), { value: 0.75 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(`editor.toolbar.slideDesignPanel.standard`)), 1)
            ]),
            _: 1
          }, 8, ["value"]),
          _createVNode(_unref(SelectOption), { value: 0.70710678 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(`editor.toolbar.slideDesignPanel.paper`)), 1)
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _createVNode(_unref(Divider)),
    _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t(`editor.toolbar.slideDesignPanel.title`)), 1),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t(`public.font.font`)) + "：", 1),
      _createVNode(_unref(Select), {
        style: {"flex":"3"},
        value: _unref(theme).fontName,
        onChange: _cache[10] || (_cache[10] = value => updateTheme({ fontName: value as string }))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(SelectOptGroup), {
            label: _unref(t)(`public.font.sysFont`)
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableFonts), (font) => {
                return (_openBlock(), _createBlock(_unref(SelectOption), {
                  key: font.value,
                  value: font.value
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      style: _normalizeStyle({ fontFamily: font.value })
                    }, _toDisplayString(font.value), 5)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t(`public.font.textColor`)) + "：", 1),
      _createVNode(_unref(Popover), { trigger: "click" }, {
        content: _withCtx(() => [
          _createVNode(ColorPicker, {
            modelValue: _unref(theme).fontColor,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = value => updateTheme({ fontColor: value }))
          }, null, 8, ["modelValue"])
        ]),
        default: _withCtx(() => [
          _createVNode(ColorButton, {
            color: _unref(theme).fontColor,
            style: {"flex":"3"}
          }, null, 8, ["color"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t(`public.font.bgColor`)) + "：", 1),
      _createVNode(_unref(Popover), { trigger: "click" }, {
        content: _withCtx(() => [
          _createVNode(ColorPicker, {
            modelValue: _unref(theme).backgroundColor,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = value => updateTheme({ backgroundColor: value }))
          }, null, 8, ["modelValue"])
        ]),
        default: _withCtx(() => [
          _createVNode(ColorButton, {
            color: _unref(theme).backgroundColor,
            style: {"flex":"3"}
          }, null, 8, ["color"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t(`editor.toolbar.slideDesignPanel.mainColor`)) + "：", 1),
      _createVNode(_unref(Popover), { trigger: "click" }, {
        content: _withCtx(() => [
          _createVNode(ColorPicker, {
            modelValue: _unref(theme).themeColor,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = value => updateTheme({ themeColor: value }))
          }, null, 8, ["modelValue"])
        ]),
        default: _withCtx(() => [
          _createVNode(ColorButton, {
            color: _unref(theme).themeColor,
            style: {"flex":"3"}
          }, null, 8, ["color"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createVNode(_unref(Button), {
        style: {"flex":"1"},
        onClick: _cache[14] || (_cache[14] = ($event: any) => (_unref(applyThemeToAllSlides)()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t(`editor.toolbar.slideDesignPanel.useMainToAll`)), 1)
        ]),
        _: 1
      })
    ]),
    _createVNode(_unref(Divider)),
    _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t(`editor.toolbar.slideDesignPanel.preMain`)), 1),
    _createElementVNode("div", _hoisted_28, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PRESET_THEMES), (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "theme-item transform_label",
          key: index,
          style: _normalizeStyle({
          backgroundColor: item.background,
          fontFamily: item.fontname,
        })
        }, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", {
              class: "text",
              style: _normalizeStyle({ color: item.fontColor })
            }, _toDisplayString(_ctx.$t(`editor.toolbar.slideDesignPanel.text`)), 5),
            _createElementVNode("div", _hoisted_30, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.colors, (color, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "color-block",
                  key: index,
                  style: _normalizeStyle({ backgroundColor: color})
                }, null, 4))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", {
                class: "btn",
                onClick: ($event: any) => (_unref(applyPresetThemeToSingleSlide)(item))
              }, _toDisplayString(_ctx.$t(`editor.toolbar.slideDesignPanel.use`)), 9, _hoisted_32),
              _createElementVNode("div", {
                class: "btn",
                onClick: ($event: any) => (_unref(applyPresetThemeToAllSlides)(item))
              }, _toDisplayString(_ctx.$t(`editor.toolbar.slideDesignPanel.useToAll`)), 9, _hoisted_33)
            ])
          ])
        ], 4))
      }), 128))
    ])
  ]))
}
}

})